/* eslint-disable */
/** UI strings: Traditional (hant) + Simplified (hans). Fallback to hant if hans omitted. */
export const STRINGS = {
  "lang.title": { hant: "介面語言", hans: "界面语言" },
  "lang.hant": { hant: "繁體中文", hans: "繁体中文" },
  "lang.hans": { hant: "簡體中文", hans: "简体中文" },
  "lang.hint": { hant: "變更後即時生效", hans: "变更后即时生效" },

  "nav.ride": { hant: "搜尋", hans: "搜寻" },
  "nav.history": { hant: "紀錄", hans: "记录" },
  "nav.profile": { hant: "個人", hans: "个人" },
  "nav.community": { hant: "社區", hans: "社区" },
  "nav.settings": { hant: "設定", hans: "设置" },

  "home.tagline": { hant: "8Go • 華人社區共乘社交平台", hans: "8Go • 华人社区共乘社交平台" },
  "home.findRide": { hant: "坐順風車", hans: "坐顺风车" },
  "home.driver": { hant: "我係車主", hans: "我是车主" },
  "home.community": { hant: "社區動態", hans: "社区动态" },
  "home.coffee": { hant: "車內 Coffee Chat", hans: "车内 Coffee Chat" },
  "home.match": { hant: "興趣配對", hans: "兴趣配对" },
  "home.verify": { hant: "實名認證", hans: "实名认证" },
  "home.admin": { hant: "管理員", hans: "管理员" },
  "home.inviteLabel": { hant: "邀請碼", hans: "邀请码" },
  "home.invitePlaceholder": { hant: "請輸入邀請碼", hans: "请输入邀请码" },
  "home.inviteSubmit": { hant: "驗證並繼續", hans: "验证并继续" },
  "home.inviteWrong": { hant: "邀請碼不正確", hans: "邀请码不正确" },
  "home.inviteHint": { hant: "請輸入有效邀請碼，方可使用叫車、車主及社區功能。", hans: "请输入有效邀请码，方可使用叫车、车主及社区功能。" },
  "home.inviteLocked": { hant: "請先完成邀請碼驗證", hans: "请先完成邀请码验证" },
  "home.inviteOk": { hant: "邀請碼已通過，可使用下方功能。", hans: "邀请码已通过，可使用下方功能。" },

  "bar.findRide": { hant: "坐順風車", hans: "坐顺风车" },
  "bar.history": { hant: "Carpool紀錄", hans: "Carpool记录" },
  "bar.profile": { hant: "個人資料", hans: "个人资料" },
  "bar.settings": { hant: "設定", hans: "设置" },
  "bar.loginPassenger": { hant: "乘客登入", hans: "乘客登录" },
  "bar.registerPassenger": { hant: "乘客註冊", hans: "乘客注册" },
  "bar.smsCode": { hant: "輸入驗證碼", hans: "输入验证码" },
  "bar.profileSetup": { hant: "設定個人資料", hans: "设置个人资料" },
  "bar.sos": { hant: "緊急聯絡人", hans: "紧急联系人" },
  "bar.addresses": { hant: "常用地址", hans: "常用地址" },
  "bar.referral": { hant: "推薦朋友", hans: "推荐朋友" },
  "bar.chooseDriver": { hant: "選擇車主", hans: "选择车主" },
  "bar.tripUpcoming": { hant: "預約待出發", hans: "预约待出发" },
  "bar.tripActive": { hant: "Carpool進行中", hans: "Carpool进行中" },

  "tab.instantCustom": { hant: "即時／自訂Carpool", hans: "即时／自定Carpool" },
  "tab.fixedRoutes": { hant: "固定路線預約", hans: "固定路线预约" },
  "tab.routeRequests": { hant: "我的路線請求", hans: "我的路线请求" },

  "bar.driverPlatform": { hant: "Carpool平台", hans: "Carpool平台" },
  "bar.driverHistory": { hant: "Carpool紀錄", hans: "Carpool记录" },
  "bar.editProfile": { hant: "編輯資料", hans: "编辑资料" },
  "bar.availability": { hant: "可用時段", hans: "可用时段" },
  "bar.fixedRoutes": { hant: "固定路線", hans: "固定路线" },
  "bar.driverLogin": { hant: "車主登入", hans: "车主登录" },
  "bar.driverRegister": { hant: "車主註冊", hans: "车主注册" },
  "bar.driverProfile": { hant: "車主資料", hans: "车主资料" },
  "bar.uploadLicense": { hant: "上載駕照", hans: "上传驾照" },
  "bar.waitVerify": { hant: "審核中", hans: "审核中" },
  "bar.pendingPassenger": { hant: "等待乘客確認", hans: "等待乘客确认" },
  "bar.waitPassengerConfirm": { hant: "等待乘客確認", hans: "等待乘客确认" },

  "tab.nowRides": { hant: "即時Carpool", hans: "即时Carpool" },
  "tab.scheduledRides": { hant: "預約Carpool", hans: "预约Carpool" },
};
